export default async function registerServiceWorker() {
    if (!("serviceWorker" in navigator)) {
        console.warn("Service workers are not supported by this browser.");
        return;
    }

    try {
        // Check if already registered
        const existingRegistration = await navigator.serviceWorker.getRegistration();
        if (existingRegistration) {
            console.log("Service Worker already registered:", existingRegistration.scope);
            return existingRegistration;
        }

        // Register new if not already
        const registration = await navigator.serviceWorker.register("/sw.js");
        console.log("Service Worker registered successfully:", registration.scope);

        return registration;
    } catch (error) {
        console.error("Service Worker registration failed:", error);
    }
}
